import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import {
  IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath';
import { IAsyncValueWidget } from '../async-value/IAsyncValueWidget';
import { IAsyncSelectWidget } from './IAsyncSelectWidget';
import { asyncSelectWidgetObjectName } from './hooks/asyncSelectObjectName';

export function getAsyncSelectOutputReferences(
  path: IReferencePath,
  widget: IAsyncSelectWidget | IAsyncValueWidget,
): IReference[] {
  // console.log(`widget.outputs`, widget.outputs);
  return (
    widget.outputs?.map(output => ({
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-${output.name}`,
      code: `${output.name}`,
      path: [
        ...path,
        {
          direction: ReferencePathDirection.Child,
          code: asyncSelectWidgetObjectName(widget.code),
        },
      ],
      field: output.type,
      label: `${widget.code}: ${output.name}`,
    })) ?? []
  );
}
